export default {
  lista: [],
  estaCarregando: false,
  filtros: {
 
  }
}
